import React from "react";
import "./styles/pp.css";

export default function Disclaimer() {
  return (
    <div className="privacy-policy-container">

      {/* Hero Section */}

      <div className="privacy-hero">

        <span className="badge">Legal</span>

        <h1>Disclaimer</h1>

        <p>
          Please read this disclaimer carefully before using MK Shops.
        </p>

        <span className="update-date">
          Effective Date: July 20, 2026
        </span>

      </div>

      {/* Body */}

      <div className="privacy-body">

        <p>
          Welcome to <strong>MK Shops</strong>. By accessing or using this
          website, you acknowledge that you have read, understood, and agreed
          to this Disclaimer.
        </p>

        <h2>
          <span className="icon">1</span>
          General Information
        </h2>

        <p>
          The information provided on MK Shops is for general informational and
          commercial purposes only. While we strive to keep all information
          accurate and up to date, we do not guarantee its completeness,
          accuracy, reliability, or availability.
        </p>

        <h2>
          <span className="icon">2</span>
          Marketplace Platform
        </h2>

        <p>
          MK Shops is an online multi-vendor marketplace where independent
          vendors can create stores and sell their products directly to
          customers.
        </p>

        <p>
          MK Shops does not manufacture, own, or directly sell products unless
          explicitly stated.
        </p>

        <h2>
          <span className="icon">3</span>
          Product Information
        </h2>

        <p>
          Product descriptions, prices, specifications, and images are provided
          by individual vendors.
        </p>

        <p>
          While we encourage vendors to provide accurate information, MK Shops
          cannot guarantee that every listing is complete, accurate, or free
          from errors.
        </p>

        <h2>
          <span className="icon">4</span>
          Vendor Responsibility
        </h2>

        <ul className="list-check">
          <li>Product quality</li>
          <li>Product descriptions</li>
          <li>Pricing</li>
          <li>Product availability</li>
          <li>Shipping information</li>
          <li>Compliance with applicable laws</li>
        </ul>

        <p>
          MK Shops is not responsible for disputes between buyers and vendors.
        </p>

        <h2>
          <span className="icon">5</span>
          Customer Reviews
        </h2>

        <p>
          Customer reviews reflect the personal opinions and experiences of
          individual users and do not necessarily represent the views of MK
          Shops.
        </p>

        <h2>
          <span className="icon">6</span>
          External Links
        </h2>

        <p>
          MK Shops may contain links to third-party websites or services. We
          are not responsible for the content, privacy practices, or security
          of third-party websites.
        </p>

        <h2>
          <span className="icon">7</span>
          Limitation of Liability
        </h2>

        <div className="highlight-box">
          <p>
            MK Shops shall not be liable for any direct, indirect, incidental,
            or consequential damages arising from the use of this website,
            purchases made through vendors, technical issues, or temporary
            service interruptions.
          </p>
        </div>

        <h2>
          <span className="icon">8</span>
          Changes to This Disclaimer
        </h2>

        <p>
          We may update this Disclaimer at any time. Changes will be published
          on this page with the updated effective date.
        </p>

        <h2>
          <span className="icon">9</span>
          Contact Us
        </h2>

        <div className="contact-box">

          <div className="contact-item">
            <span className="label">Website</span>
            <span className="value">MK Shops</span>
          </div>

          <div className="contact-item">
            <span className="label">Email</span>
            <span className="value">
              <a href="mailto:mktorushops@gmail.com">
                mktorushops@gmail.com
              </a>
            </span>
          </div>

          <div className="contact-item">
            <span className="label">Support</span>
            <span className="value">
              We will respond to your inquiry as soon as possible.
            </span>
          </div>

        </div>

      </div>

    </div>
  );
}